"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactBootstrap = require("react-bootstrap");

var _API = require("../../API");

var _StatusWrapper = require("../../../components/StatusWrapper");

var _StatusWrapper2 = _interopRequireDefault(_StatusWrapper);

var _reactIntl = require("react-intl");

var _reactCssModules = require("react-css-modules");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _mapToState = require("../../mapToState");

var _FileUpload = require("../../../components/FileUpload");

var _FileUpload2 = _interopRequireDefault(_FileUpload);

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var styles = require("./ReportDetailImageFieldTemplate.less");

var ReportDetailImageFieldTemplate = function (_React$Component) {
    _inherits(ReportDetailImageFieldTemplate, _React$Component);

    function ReportDetailImageFieldTemplate(props) {
        _classCallCheck(this, ReportDetailImageFieldTemplate);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReportDetailImageFieldTemplate).call(this, props));

        _this.onHide = function () {
            _this.setState({
                showModal: false,
                hasFile: _this.state.hasFile,
                isLoading: _this.state.isLoading
            });
        };
        _this.onShow = function () {
            _this.setState({
                showModal: true,
                hasFile: false,
                isLoading: _this.state.isLoading
            });
        };
        _this.onUploadImage = function () {
            var tempRefs = _this.refs;
            var file = tempRefs.filePicker.getFile();
            if (file) {
                (function () {
                    var target = _API.API.uploadAttachment(_this.props.reportDetail.selectedReport.uid, _this.props.fieldUid, file, "field");
                    (0, _mapToState.mapToState)(function () {
                        return _this;
                    }, function () {
                        return _API.client.requestJSON(target).then(function (value) {
                            _this.props.addItem(value.attachmentUid, _this.props.dispatch);
                            _this.onHide();
                        });
                    });
                })();
            }
        };
        _this.onPictureAvailableChanged = function (e) {
            var state = _this.state;
            state.hasFile = e ? true : false;
            _this.setState(state);
        };
        _this.onDeleteAttachment = function (attachmentUid) {
            var target = _API.API.deleteAttachment(_this.props.reportDetail.selectedReport.uid, attachmentUid);
            (0, _mapToState.mapToState)(function () {
                return _this;
            }, function () {
                return _API.client.requestJSON(target).then(function (value) {
                    _this.props.removeItem(attachmentUid, _this.props.dispatch);
                    _this.onHide();
                });
            });
            return;
        };
        _this.state = {
            showModal: false,
            hasFile: false,
            isLoading: false
        };
        return _this;
    }

    _createClass(ReportDetailImageFieldTemplate, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var modal = React.createElement(_reactBootstrap.Modal, { show: this.state.showModal, onHide: this.onHide, enforceFocus: false }, React.createElement(_StatusWrapper2.default, { isLoading: this.state.isLoading, error: this.state.error, onDismissError: this.state.dismissError }, React.createElement(_reactBootstrap.Modal.Header, { closeButton: true }, React.createElement(_reactBootstrap.Modal.Title, null, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.steps.uploadImage" }))), React.createElement(_reactBootstrap.Modal.Body, null, React.createElement(_FileUpload2.default, { noPdf: true, ref: "filePicker", handleFileChange: this.onPictureAvailableChanged })), React.createElement(_reactBootstrap.Modal.Footer, null, React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 12 }, React.createElement(_reactBootstrap.ButtonGroup, null, React.createElement(_reactBootstrap.Button, { bsStyle: "primary", disabled: !this.state.hasFile, onClick: this.onUploadImage }, React.createElement("i", { className: "fa fa-upload" }), " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.steps.uploadImage" }))))))));
            var attachmentUid = this.props.locals.value;
            var attachment = {
                attachmentUrl: __API_BASE_URL__ + "/assets/attachments/reports/" + this.props.reportDetail.selectedReport.uid + "/" + attachmentUid,
                attachmentUid: attachmentUid
            };
            var extension = "";
            if (attachmentUid.indexOf("PDF") !== -1) {
                extension = ".pdf";
            } else {
                extension = ".png";
            }
            var attachmentElement = React.createElement("div", { style: { display: "inline-block", textAlign: "center" } }, React.createElement("ul", { styleName: "image-gallery" }, function () {
                if (attachmentUid) {
                    return React.createElement("li", null, React.createElement("a", { href: attachment.attachmentUrl + extension, target: "_blank" }, React.createElement("img", { style: { "max-width": "450px", "max-height": "200px" }, src: attachment.attachmentUrl + "THUMBNAIL" + ".png" })));
                }
            }()), React.createElement("div", { style: { clear: "both" } }));
            return React.createElement(_reactBootstrap.Panel, { header: this.props.title, bsStyle: this.props.locals.hasError ? "danger" : "default" }, function () {
                if (_this2.props.locals.help) {
                    return _this2.props.locals.help;
                }
            }(), React.createElement(_StatusWrapper2.default, { isLoading: this.state.isLoading, error: this.state.error, onDismissError: this.state.dismissError }, attachmentElement, React.createElement(_reactBootstrap.ButtonGroup, { style: { display: "block" } }, React.createElement(_reactBootstrap.Button, { bsStyle: "primary", disabled: this.props.locals.disabled, onClick: this.onShow }, React.createElement("i", { className: "fa fa-upload" }), " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.steps.uploadImage" })), React.createElement(_reactBootstrap.Button, { bsStyle: "default", disabled: !attachmentUid || this.props.locals.disabled, onClick: function onClick() {
                    return _this2.onDeleteAttachment(attachment.attachmentUid);
                } }, React.createElement("i", { className: "fa fa-times" }), " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.steps.deleteImage" })))), modal);
        }
    }]);

    return ReportDetailImageFieldTemplate;
}(React.Component);
ReportDetailImageFieldTemplate = __decorate([_reactIntl.injectIntl, (0, _reactRedux.connect)(function (state) {
    return {
        reportDetail: state.reportDetail
    };
}), (0, _reactCssModules2.default)(styles)], ReportDetailImageFieldTemplate);
exports.default = ReportDetailImageFieldTemplate;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailImageFieldTemplate.tsx
 ** module id = 1277
 ** module chunks = 0
 **/